import { css } from '@emotion/react';
import { withPrefix } from 'gatsby';

export type ToolCardProps = {
  className?: string;
  head: React.ReactNode;
  text?: string;
  items?: string[];
  caution?: string;
  imageSrc: string;
  option?: boolean;
};

export const ToolCard: React.FC<ToolCardProps> = ({
  className,
  head,
  text,
  items = [],
  caution,
  imageSrc,
  option,
}) => {
  return (
    <div
      css={css`
        position: relative;
        background: #fff;
        padding: 15px 25px 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-height: 290px;
        box-shadow: 0px 4px 16px #2c28281c;
        border-radius: 12px;
      `}
      className={className}
    >
      {option && (
        <div
          css={css`
            position: absolute;
            top: 18px;
            left: 0;
          `}
        >
          <img src={withPrefix('/images/tool/tool-option_mark.png')} alt="" width="86" />
        </div>
      )}
      <div
        css={css`
          width: max-content;
          margin: 0 auto 24px;
        `}
      >
        <img src={imageSrc} alt="" width="150" height="108" />
      </div>
      <p
        css={css`
          text-align: center;
          font: normal normal 500 16px/24px 'Noto Sans JP', sans-serif;
          letter-spacing: 0.64px;
          color: #00b3a7;
        `}
      >
        {head}
      </p>
      {text && (
        <p
          css={css`
            text-align: center;
            font: normal normal normal 14px/22px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.56px;
            color: #444b57;
            margin-top: 15px;
            white-space: pre-line;
          `}
        >
          {text}
        </p>
      )}
      {items.length > 0 && (
        <ul
          css={css`
            width: fit-content;
            margin: auto;
            margin-top: 15px;
          `}
        >
          {items.map((item, i) => (
            <li
              key={i}
              css={css`
                display: flex;
                align-items: center;
                gap: 6px;
                font: normal normal normal 14px/22px 'Noto Sans JP', sans-serif;
                letter-spacing: 0.56px;
                color: #444b57;

                &::before {
                  content: '';
                  flex-shrink: 0;
                  display: block;
                  width: 8px;
                  height: 8px;
                  border-radius: 50%;
                  background: #00b3a7;
                  margin-top: 1px;
                }
              `}
            >
              <p>{item}</p>
            </li>
          ))}
        </ul>
      )}
      {caution && (
        <p
          css={css`
            margin: 8px 15px 0;
            font: normal normal normal 10px/11px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.4px;
            color: #444b57;
          `}
        >
          {caution}
        </p>
      )}
    </div>
  );
};
